// Medical Scores Database - Complete Collection Part 12
// Additional scores from medicalcul.free.fr - C-F section

import {
  Brain,
  Heart,
  Wind,
  Activity,
  Baby,
  Stethoscope,
  Thermometer,
  Droplets,
  Flame,
  Syringe,
  Pill,
  Bone,
  Scale,
  Clock,
  AlertTriangle,
  Calculator,
  User,
  Beaker,
  Target
} from 'lucide-react';

export const SCORES_PART_12 = {
  // ==================== SCORES C ====================
  cageDeta: {
    name: 'CAGE-DETA (Dépendance alcool)',
    category: 'Toxicologie',
    icon: Pill,
    description: 'Dépistage dépendance à l\'alcool',
    color: 'amber',
    fields: [
      { id: 'cutDown', label: 'Avez-vous ressenti le besoin de Diminuer votre consommation?', type: 'checkbox', points: 1 },
      { id: 'annoyed', label: 'Votre Entourage vous a-t-il fait des remarques?', type: 'checkbox', points: 1 },
      { id: 'guilty', label: 'Avez-vous eu l\'impression que vous buviez Trop?', type: 'checkbox', points: 1 },
      { id: 'eyeOpener', label: 'Avez-vous besoin d\'Alcool dès le matin?', type: 'checkbox', points: 1 }
    ],
    calculate: (values) => {
      let total = 0;
      if (values.cutDown) total += 1;
      if (values.annoyed) total += 1;
      if (values.guilty) total += 1;
      if (values.eyeOpener) total += 1;
      return { score: total, max: 4 };
    },
    interpret: (score) => {
      if (score === 0) return { level: 'success', text: `CAGE ${score}/4`, detail: 'Pas de problème avec l\'alcool détecté.' };
      if (score === 1) return { level: 'warning', text: `CAGE ${score}/4`, detail: 'Usage à risque possible. Approfondir l\'évaluation.' };
      return { level: 'danger', text: `CAGE ${score}/4`, detail: 'Forte probabilité de dépendance à l\'alcool. Prise en charge recommandée.' };
    },
    formula: 'CAGE ≥ 2 = forte probabilité de dépendance alcoolique (Se 93%, Sp 76%)'
  },

  caprini2005: {
    name: 'Caprini 2005 (Risque thromboembolique)',
    category: 'Anesthésie',
    icon: Syringe,
    description: 'Risque embolique post-opératoire',
    color: 'red',
    fields: [
      { id: 'age41_60', label: 'Âge 41-60 ans', type: 'checkbox', points: 1 },
      { id: 'age61_74', label: 'Âge 61-74 ans', type: 'checkbox', points: 2 },
      { id: 'age75', label: 'Âge ≥ 75 ans', type: 'checkbox', points: 3 },
      { id: 'surgery_minor', label: 'Chirurgie mineure', type: 'checkbox', points: 1 },
      { id: 'surgery_major', label: 'Chirurgie majeure (> 45 min)', type: 'checkbox', points: 2 },
      { id: 'bmi', label: 'BMI > 25', type: 'checkbox', points: 1 },
      { id: 'varicose', label: 'Varices', type: 'checkbox', points: 1 },
      { id: 'pregnancy', label: 'Grossesse ou post-partum', type: 'checkbox', points: 1 },
      { id: 'ocp', label: 'Contraception/THS', type: 'checkbox', points: 1 },
      { id: 'sepsis', label: 'Sepsis (< 1 mois)', type: 'checkbox', points: 1 },
      { id: 'chf', label: 'Insuffisance cardiaque (< 1 mois)', type: 'checkbox', points: 1 },
      { id: 'immobilization', label: 'Immobilisation plâtrée', type: 'checkbox', points: 2 },
      { id: 'cvk', label: 'Cathéter veineux central', type: 'checkbox', points: 2 },
      { id: 'cancer', label: 'Cancer', type: 'checkbox', points: 2 },
      { id: 'history_dvt', label: 'ATCD thrombose', type: 'checkbox', points: 3 },
      { id: 'thrombophilia', label: 'Thrombophilie connue', type: 'checkbox', points: 3 },
      { id: 'stroke', label: 'AVC (< 1 mois)', type: 'checkbox', points: 5 },
      { id: 'hip_knee', label: 'Prothèse hanche/genou', type: 'checkbox', points: 5 },
      { id: 'fracture', label: 'Fracture hanche/pelvis/jambe', type: 'checkbox', points: 5 },
      { id: 'trauma', label: 'Traumatisme majeur (< 1 mois)', type: 'checkbox', points: 5 }
    ],
    calculate: (values) => {
      let total = 0;
      if (values.age41_60) total += 1;
      if (values.age61_74) total += 2;
      if (values.age75) total += 3;
      if (values.surgery_minor) total += 1;
      if (values.surgery_major) total += 2;
      if (values.bmi) total += 1;
      if (values.varicose) total += 1;
      if (values.pregnancy) total += 1;
      if (values.ocp) total += 1;
      if (values.sepsis) total += 1;
      if (values.chf) total += 1;
      if (values.immobilization) total += 2;
      if (values.cvk) total += 2;
      if (values.cancer) total += 2;
      if (values.history_dvt) total += 3;
      if (values.thrombophilia) total += 3;
      if (values.stroke) total += 5;
      if (values.hip_knee) total += 5;
      if (values.fracture) total += 5;
      if (values.trauma) total += 5;
      return { score: total, max: 'variable' };
    },
    interpret: (score) => {
      if (score === 0) return { level: 'success', text: `Caprini ${score}`, detail: 'Risque très faible (~0.5%). Mobilisation précoce.' };
      if (score <= 2) return { level: 'success', text: `Caprini ${score}`, detail: 'Risque faible (~1.5%). Prophylaxie mécanique (CPI).' };
      if (score <= 4) return { level: 'warning', text: `Caprini ${score}`, detail: 'Risque modéré (~3%). Prophylaxie médicamenteuse (HBPM).' };
      return { level: 'danger', text: `Caprini ${score}`, detail: 'Risque élevé (>6%). Prophylaxie prolongée HBPM + CPI.' };
    },
    formula: '0: très faible. 1-2: faible. 3-4: modéré. ≥5: élevé'
  },

  ccmu: {
    name: 'CCMU (Classification Clinique Malades Urgences)',
    category: 'Urgences',
    icon: Stethoscope,
    description: 'Degré de gravité à l\'entrée aux urgences',
    color: 'blue',
    fields: [
      { id: 'class', label: 'Classification CCMU', type: 'select', options: [
        { value: 1, label: 'CCMU 1 - État lésionnel jugé stable' },
        { value: 2, label: 'CCMU 2 - État lésionnel stable, nécessite acte diagnostique/thérapeutique' },
        { value: 3, label: 'CCMU 3 - État susceptible de s\'aggraver sans mise en jeu du pronostic vital' },
        { value: 4, label: 'CCMU 4 - Pronostic vital engagé, pas de geste réanimation immédiat' },
        { value: 5, label: 'CCMU 5 - Pronostic vital engagé, geste réanimation immédiat' },
        { value: 6, label: 'CCMU P - Patient déclaré décédé avant tout acte médical' },
        { value: 7, label: 'CCMU D - Patient décédé après gestes réanimation' }
      ]}
    ],
    calculate: (values) => {
      return { score: values.class || 1, max: 'Classification' };
    },
    interpret: (score) => {
      if (score === 1) return { level: 'success', text: 'CCMU 1', detail: 'État stable, abstention thérapeutique aux urgences ou acte unique.' };
      if (score === 2) return { level: 'success', text: 'CCMU 2', detail: 'État stable, nécessite investigations ou thérapeutique aux urgences.' };
      if (score === 3) return { level: 'warning', text: 'CCMU 3', detail: 'État instable, risque d\'aggravation. Surveillance attentive.' };
      if (score === 4) return { level: 'danger', text: 'CCMU 4', detail: 'Pronostic vital en jeu. Pas de réanimation immédiate nécessaire.' };
      if (score === 5) return { level: 'danger', text: 'CCMU 5', detail: 'Pronostic vital en jeu. Réanimation immédiate nécessaire.' };
      if (score === 6) return { level: 'danger', text: 'CCMU P', detail: 'Décès constaté avant tout acte médical.' };
      return { level: 'danger', text: 'CCMU D', detail: 'Décès après manœuvres de réanimation.' };
    },
    formula: 'Classification française des urgences médicales'
  },

  charlsonIndex: {
    name: 'Charlson (Index de comorbidités)',
    category: 'Médecine interne',
    icon: User,
    description: 'Survie selon comorbidités et âge',
    color: 'violet',
    fields: [
      { id: 'mi', label: 'Infarctus du myocarde', type: 'checkbox', points: 1 },
      { id: 'chf', label: 'Insuffisance cardiaque', type: 'checkbox', points: 1 },
      { id: 'pvd', label: 'Artériopathie périphérique', type: 'checkbox', points: 1 },
      { id: 'cva', label: 'AVC sans séquelle ou AIT', type: 'checkbox', points: 1 },
      { id: 'dementia', label: 'Démence', type: 'checkbox', points: 1 },
      { id: 'copd', label: 'BPCO', type: 'checkbox', points: 1 },
      { id: 'ctd', label: 'Connectivite', type: 'checkbox', points: 1 },
      { id: 'ulcer', label: 'Ulcère gastroduodénal', type: 'checkbox', points: 1 },
      { id: 'liver_mild', label: 'Hépatopathie légère', type: 'checkbox', points: 1 },
      { id: 'diabetes', label: 'Diabète sans complication', type: 'checkbox', points: 1 },
      { id: 'hemiplegia', label: 'Hémiplégie', type: 'checkbox', points: 2 },
      { id: 'ckd', label: 'Insuffisance rénale modérée/sévère', type: 'checkbox', points: 2 },
      { id: 'diabetes_comp', label: 'Diabète avec complications', type: 'checkbox', points: 2 },
      { id: 'cancer', label: 'Cancer (solide) sans métastase', type: 'checkbox', points: 2 },
      { id: 'leukemia', label: 'Leucémie', type: 'checkbox', points: 2 },
      { id: 'lymphoma', label: 'Lymphome', type: 'checkbox', points: 2 },
      { id: 'liver_severe', label: 'Hépatopathie modérée/sévère', type: 'checkbox', points: 3 },
      { id: 'cancer_meta', label: 'Cancer métastatique', type: 'checkbox', points: 6 },
      { id: 'aids', label: 'SIDA', type: 'checkbox', points: 6 },
      { id: 'age', label: 'Âge', type: 'select', options: [
        { value: 0, label: '< 50 ans' },
        { value: 1, label: '50-59 ans' },
        { value: 2, label: '60-69 ans' },
        { value: 3, label: '70-79 ans' },
        { value: 4, label: '≥ 80 ans' }
      ]}
    ],
    calculate: (values) => {
      let total = values.age || 0;
      if (values.mi) total += 1;
      if (values.chf) total += 1;
      if (values.pvd) total += 1;
      if (values.cva) total += 1;
      if (values.dementia) total += 1;
      if (values.copd) total += 1;
      if (values.ctd) total += 1;
      if (values.ulcer) total += 1;
      if (values.liver_mild) total += 1;
      if (values.diabetes) total += 1;
      if (values.hemiplegia) total += 2;
      if (values.ckd) total += 2;
      if (values.diabetes_comp) total += 2;
      if (values.cancer) total += 2;
      if (values.leukemia) total += 2;
      if (values.lymphoma) total += 2;
      if (values.liver_severe) total += 3;
      if (values.cancer_meta) total += 6;
      if (values.aids) total += 6;
      return { score: total, max: 'variable' };
    },
    interpret: (score) => {
      if (score === 0) return { level: 'success', text: `Charlson ${score}`, detail: 'Survie estimée à 10 ans: 99%' };
      if (score <= 2) return { level: 'success', text: `Charlson ${score}`, detail: 'Survie estimée à 10 ans: 90%' };
      if (score <= 4) return { level: 'warning', text: `Charlson ${score}`, detail: 'Survie estimée à 10 ans: 53%' };
      if (score <= 6) return { level: 'warning', text: `Charlson ${score}`, detail: 'Survie estimée à 10 ans: 21%' };
      return { level: 'danger', text: `Charlson ${score}`, detail: 'Survie estimée à 10 ans: < 10%' };
    },
    formula: 'Index ajusté à l\'âge. Utilisé pour pronostic et ajustement études.'
  },

  ciwaAr: {
    name: 'CIWA-Ar (Sevrage alcoolique)',
    category: 'Toxicologie',
    icon: Pill,
    description: 'Sévérité pré-delirium tremens sur sevrage alcoolique',
    color: 'amber',
    fields: [
      { id: 'nausea', label: 'Nausées/vomissements', type: 'select', options: [
        { value: 0, label: '0 - Aucun' },
        { value: 1, label: '1 - Légères nausées' },
        { value: 4, label: '4 - Nausées intermittentes' },
        { value: 7, label: '7 - Nausées constantes, vomissements' }
      ]},
      { id: 'tremor', label: 'Tremblements', type: 'select', options: [
        { value: 0, label: '0 - Aucun' },
        { value: 1, label: '1 - Non visibles, palpables' },
        { value: 4, label: '4 - Modérés, bras tendus' },
        { value: 7, label: '7 - Sévères, même au repos' }
      ]},
      { id: 'sweating', label: 'Sueurs', type: 'select', options: [
        { value: 0, label: '0 - Aucune' },
        { value: 1, label: '1 - Paumes humides' },
        { value: 4, label: '4 - Front perlé' },
        { value: 7, label: '7 - Profuses généralisées' }
      ]},
      { id: 'anxiety', label: 'Anxiété', type: 'select', options: [
        { value: 0, label: '0 - Calme' },
        { value: 1, label: '1 - Légèrement anxieux' },
        { value: 4, label: '4 - Modérément anxieux' },
        { value: 7, label: '7 - Équivalent panique aiguë' }
      ]},
      { id: 'agitation', label: 'Agitation', type: 'select', options: [
        { value: 0, label: '0 - Activité normale' },
        { value: 1, label: '1 - Plus actif que normal' },
        { value: 4, label: '4 - Modérément agité' },
        { value: 7, label: '7 - Arpente, ne tient pas en place' }
      ]},
      { id: 'tactile', label: 'Troubles tactiles', type: 'select', options: [
        { value: 0, label: '0 - Aucun' },
        { value: 1, label: '1 - Paresthésies légères' },
        { value: 4, label: '4 - Hallucinations tactiles modérées' },
        { value: 7, label: '7 - Hallucinations continues' }
      ]},
      { id: 'auditory', label: 'Troubles auditifs', type: 'select', options: [
        { value: 0, label: '0 - Aucun' },
        { value: 1, label: '1 - Sons plus forts/effrayants' },
        { value: 4, label: '4 - Hallucinations auditives modérées' },
        { value: 7, label: '7 - Hallucinations continues' }
      ]},
      { id: 'visual', label: 'Troubles visuels', type: 'select', options: [
        { value: 0, label: '0 - Aucun' },
        { value: 1, label: '1 - Photosensibilité légère' },
        { value: 4, label: '4 - Hallucinations visuelles modérées' },
        { value: 7, label: '7 - Hallucinations continues' }
      ]},
      { id: 'headache', label: 'Céphalées', type: 'select', options: [
        { value: 0, label: '0 - Aucune' },
        { value: 1, label: '1 - Très légères' },
        { value: 4, label: '4 - Modérées' },
        { value: 7, label: '7 - Sévères' }
      ]},
      { id: 'orientation', label: 'Orientation', type: 'select', options: [
        { value: 0, label: '0 - Orienté' },
        { value: 1, label: '1 - Incertain sur date' },
        { value: 2, label: '2 - Désorienté temps < 2j' },
        { value: 3, label: '3 - Désorienté temps > 2j' },
        { value: 4, label: '4 - Désorienté temps et lieu' }
      ]}
    ],
    calculate: (values) => {
      const total = (values.nausea || 0) + (values.tremor || 0) + (values.sweating || 0) +
                    (values.anxiety || 0) + (values.agitation || 0) + (values.tactile || 0) +
                    (values.auditory || 0) + (values.visual || 0) + (values.headache || 0) +
                    (values.orientation || 0);
      return { score: total, max: 67 };
    },
    interpret: (score) => {
      if (score <= 8) return { level: 'success', text: `CIWA-Ar ${score}`, detail: 'Sevrage léger. Pas de traitement médicamenteux nécessaire.' };
      if (score <= 15) return { level: 'warning', text: `CIWA-Ar ${score}`, detail: 'Sevrage modéré. Benzodiazépines à envisager.' };
      if (score <= 20) return { level: 'danger', text: `CIWA-Ar ${score}`, detail: 'Sevrage sévère. Traitement par benzodiazépines indiqué.' };
      return { level: 'danger', text: `CIWA-Ar ${score}`, detail: 'Sevrage très sévère. Risque delirium tremens. USI recommandée.' };
    },
    formula: '< 10: léger. 10-15: modéré. > 15: sévère. > 20: très sévère'
  },

  // ==================== SCORES D-F ====================
  dakar: {
    name: 'Dakar (Gravité tétanos)',
    category: 'Infectiologie',
    icon: Thermometer,
    description: 'Évaluation gravité du tétanos',
    color: 'rose',
    fields: [
      { id: 'incubation', label: 'Période d\'incubation', type: 'select', options: [
        { value: 0, label: '≥ 7 jours' },
        { value: 1, label: '< 7 jours' }
      ]},
      { id: 'invasion', label: 'Période d\'invasion', type: 'select', options: [
        { value: 0, label: '≥ 2 jours' },
        { value: 1, label: '< 2 jours' }
      ]},
      { id: 'portal', label: 'Porte d\'entrée', type: 'select', options: [
        { value: 0, label: 'Non identifiée ou périphérique' },
        { value: 1, label: 'Utérine, brûlure, fracture ouverte, IM' }
      ]},
      { id: 'spasm', label: 'Spasmes généralisés', type: 'select', options: [
        { value: 0, label: 'Absents' },
        { value: 1, label: 'Présents' }
      ]},
      { id: 'temp', label: 'Température rectale', type: 'select', options: [
        { value: 0, label: '< 38.4°C' },
        { value: 1, label: '≥ 38.4°C' }
      ]},
      { id: 'hr', label: 'Fréquence cardiaque', type: 'select', options: [
        { value: 0, label: '< 120/min' },
        { value: 1, label: '≥ 120/min' }
      ]}
    ],
    calculate: (values) => {
      const total = (values.incubation || 0) + (values.invasion || 0) + (values.portal || 0) +
                    (values.spasm || 0) + (values.temp || 0) + (values.hr || 0);
      return { score: total, max: 6 };
    },
    interpret: (score) => {
      if (score <= 1) return { level: 'success', text: `Dakar ${score}/6`, detail: 'Grade I - Mortalité ~10%. Pronostic favorable.' };
      if (score <= 3) return { level: 'warning', text: `Dakar ${score}/6`, detail: 'Grade II - Mortalité ~20-30%. Surveillance USI.' };
      return { level: 'danger', text: `Dakar ${score}/6`, detail: 'Grade III - Mortalité > 50%. Réanimation intensive.' };
    },
    formula: '0-1: Grade I. 2-3: Grade II. 4-6: Grade III'
  },

  epworth: {
    name: 'Epworth (Somnolence)',
    category: 'Neurologie',
    icon: Brain,
    description: 'Dépistage sommeil pathologique / apnées',
    color: 'purple',
    fields: [
      { id: 'reading', label: 'Assis en train de lire', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]},
      { id: 'tv', label: 'En regardant la TV', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]},
      { id: 'public', label: 'Assis inactif lieu public', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]},
      { id: 'car', label: 'Passager voiture (1h)', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]},
      { id: 'lying', label: 'Allongé après-midi', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]},
      { id: 'talking', label: 'Assis en parlant à quelqu\'un', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]},
      { id: 'lunch', label: 'Assis après déjeuner sans alcool', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]},
      { id: 'traffic', label: 'En voiture arrêtée dans trafic', type: 'select', options: [
        { value: 0, label: '0 - Jamais' },
        { value: 1, label: '1 - Faible chance' },
        { value: 2, label: '2 - Chance moyenne' },
        { value: 3, label: '3 - Forte chance' }
      ]}
    ],
    calculate: (values) => {
      const total = (values.reading || 0) + (values.tv || 0) + (values.public || 0) +
                    (values.car || 0) + (values.lying || 0) + (values.talking || 0) +
                    (values.lunch || 0) + (values.traffic || 0);
      return { score: total, max: 24 };
    },
    interpret: (score) => {
      if (score <= 5) return { level: 'success', text: `Epworth ${score}/24`, detail: 'Somnolence faible. Pas de pathologie du sommeil évidente.' };
      if (score <= 10) return { level: 'success', text: `Epworth ${score}/24`, detail: 'Somnolence normale. Pas de bilan du sommeil nécessaire.' };
      if (score <= 15) return { level: 'warning', text: `Epworth ${score}/24`, detail: 'Somnolence diurne excessive. Bilan du sommeil recommandé.' };
      return { level: 'danger', text: `Epworth ${score}/24`, detail: 'Somnolence sévère. Polysomnographie urgente. Attention conduite.' };
    },
    formula: '≤ 10: normal. 11-15: excessif. > 15: sévère'
  },

  findrisc: {
    name: 'FINDRISC (Risque diabète)',
    category: 'Médecine interne',
    icon: Beaker,
    description: 'Risque de développer un diabète type 2 à 10 ans',
    color: 'orange',
    fields: [
      { id: 'age', label: 'Âge', type: 'select', options: [
        { value: 0, label: '< 45 ans' },
        { value: 2, label: '45-54 ans' },
        { value: 3, label: '55-64 ans' },
        { value: 4, label: '> 64 ans' }
      ]},
      { id: 'bmi', label: 'IMC (kg/m²)', type: 'select', options: [
        { value: 0, label: '< 25' },
        { value: 1, label: '25-30' },
        { value: 3, label: '> 30' }
      ]},
      { id: 'waist', label: 'Tour de taille', type: 'select', options: [
        { value: 0, label: 'H < 94cm / F < 80cm' },
        { value: 3, label: 'H 94-102cm / F 80-88cm' },
        { value: 4, label: 'H > 102cm / F > 88cm' }
      ]},
      { id: 'activity', label: 'Activité physique (30min/j)', type: 'select', options: [
        { value: 0, label: 'Oui' },
        { value: 2, label: 'Non' }
      ]},
      { id: 'vegetables', label: 'Fruits/légumes quotidiens', type: 'select', options: [
        { value: 0, label: 'Oui' },
        { value: 1, label: 'Non' }
      ]},
      { id: 'hta', label: 'Traitement HTA', type: 'checkbox', points: 2 },
      { id: 'hyperglycemia', label: 'ATCD hyperglycémie', type: 'checkbox', points: 5 },
      { id: 'family', label: 'ATCD familial diabète', type: 'select', options: [
        { value: 0, label: 'Non' },
        { value: 3, label: 'Oui - 2e degré' },
        { value: 5, label: 'Oui - 1er degré' }
      ]}
    ],
    calculate: (values) => {
      let total = (values.age || 0) + (values.bmi || 0) + (values.waist || 0) +
                  (values.activity || 0) + (values.vegetables || 0) + (values.family || 0);
      if (values.hta) total += 2;
      if (values.hyperglycemia) total += 5;
      return { score: total, max: 26 };
    },
    interpret: (score) => {
      if (score < 7) return { level: 'success', text: `FINDRISC ${score}`, detail: 'Risque faible (~1%). Maintenir hygiène de vie.' };
      if (score < 12) return { level: 'success', text: `FINDRISC ${score}`, detail: 'Risque légèrement élevé (~4%). Conseils diététiques.' };
      if (score < 15) return { level: 'warning', text: `FINDRISC ${score}`, detail: 'Risque modéré (~17%). Glycémie à jeun recommandée.' };
      if (score < 20) return { level: 'danger', text: `FINDRISC ${score}`, detail: 'Risque élevé (~33%). Dépistage glycémique urgent.' };
      return { level: 'danger', text: `FINDRISC ${score}`, detail: 'Risque très élevé (~50%). HGPO recommandée.' };
    },
    formula: '< 7: faible. 7-11: légèrement élevé. 12-14: modéré. 15-20: élevé. > 20: très élevé'
  },

  fagerstrom: {
    name: 'Fagerström (Dépendance nicotine)',
    category: 'Toxicologie',
    icon: Pill,
    description: 'Évaluation dépendance à la nicotine',
    color: 'amber',
    fields: [
      { id: 'morning', label: 'Délai 1ère cigarette après réveil', type: 'select', options: [
        { value: 3, label: '≤ 5 min' },
        { value: 2, label: '6-30 min' },
        { value: 1, label: '31-60 min' },
        { value: 0, label: '> 60 min' }
      ]},
      { id: 'difficult', label: 'Difficile de ne pas fumer dans lieux interdits', type: 'select', options: [
        { value: 1, label: 'Oui' },
        { value: 0, label: 'Non' }
      ]},
      { id: 'hardest', label: 'Cigarette la plus difficile à ne pas fumer', type: 'select', options: [
        { value: 1, label: 'La première du matin' },
        { value: 0, label: 'Une autre' }
      ]},
      { id: 'perDay', label: 'Nombre cigarettes par jour', type: 'select', options: [
        { value: 0, label: '≤ 10' },
        { value: 1, label: '11-20' },
        { value: 2, label: '21-30' },
        { value: 3, label: '> 30' }
      ]},
      { id: 'moreSmoking', label: 'Plus fumer le matin que l\'après-midi', type: 'select', options: [
        { value: 1, label: 'Oui' },
        { value: 0, label: 'Non' }
      ]},
      { id: 'sick', label: 'Fumer même malade, alité', type: 'select', options: [
        { value: 1, label: 'Oui' },
        { value: 0, label: 'Non' }
      ]}
    ],
    calculate: (values) => {
      const total = (values.morning || 0) + (values.difficult || 0) + (values.hardest || 0) +
                    (values.perDay || 0) + (values.moreSmoking || 0) + (values.sick || 0);
      return { score: total, max: 10 };
    },
    interpret: (score) => {
      if (score <= 2) return { level: 'success', text: `Fagerström ${score}/10`, detail: 'Dépendance faible. Sevrage sans substitution possible.' };
      if (score <= 4) return { level: 'success', text: `Fagerström ${score}/10`, detail: 'Dépendance faible à modérée. Substitution nicotinique optionnelle.' };
      if (score <= 6) return { level: 'warning', text: `Fagerström ${score}/10`, detail: 'Dépendance modérée. Substitution nicotinique recommandée.' };
      if (score <= 7) return { level: 'warning', text: `Fagerström ${score}/10`, detail: 'Dépendance forte. Substitution nicotinique indispensable.' };
      return { level: 'danger', text: `Fagerström ${score}/10`, detail: 'Dépendance très forte. Traitement combiné recommandé.' };
    },
    formula: '0-2: faible. 3-4: modéré. 5-6: forte. ≥7: très forte'
  },

  fernandez: {
    name: 'Fernandez (GEU)',
    category: 'Obstétrique',
    icon: Baby,
    description: 'Décision thérapeutique grossesse extra-utérine',
    color: 'pink',
    fields: [
      { id: 'hcg', label: 'β-HCG plasmatique (UI/L)', type: 'select', options: [
        { value: 1, label: '< 1000' },
        { value: 2, label: '1000-4999' },
        { value: 3, label: '≥ 5000' }
      ]},
      { id: 'progression', label: 'Progression β-HCG à 48h', type: 'select', options: [
        { value: 1, label: 'Décroissante' },
        { value: 2, label: 'Stable' },
        { value: 3, label: 'Croissante' }
      ]},
      { id: 'hematosalpinx', label: 'Hématosalpinx (cm)', type: 'select', options: [
        { value: 1, label: '< 1 cm' },
        { value: 2, label: '1-3 cm' },
        { value: 3, label: '> 3 cm' }
      ]},
      { id: 'hemoperitoneum', label: 'Hémopéritoine', type: 'select', options: [
        { value: 1, label: 'Absent' },
        { value: 2, label: '< 100 mL' },
        { value: 3, label: '> 100 mL' }
      ]},
      { id: 'progesterone', label: 'Progestéronémie (ng/mL)', type: 'select', options: [
        { value: 1, label: '< 5' },
        { value: 2, label: '5-10' },
        { value: 3, label: '> 10' }
      ]},
      { id: 'pain', label: 'Douleur', type: 'select', options: [
        { value: 1, label: 'Absente' },
        { value: 2, label: 'Provoquée' },
        { value: 3, label: 'Spontanée' }
      ]}
    ],
    calculate: (values) => {
      const total = (values.hcg || 1) + (values.progression || 1) + (values.hematosalpinx || 1) +
                    (values.hemoperitoneum || 1) + (values.progesterone || 1) + (values.pain || 1);
      return { score: total, max: 18 };
    },
    interpret: (score) => {
      if (score <= 12) return { level: 'success', text: `Fernandez ${score}/18`, detail: 'Traitement médical (méthotrexate) envisageable. Succès ~90%.' };
      return { level: 'danger', text: `Fernandez ${score}/18`, detail: 'Traitement chirurgical recommandé. Risque échec médical.' };
    },
    formula: 'Score ≤ 12: traitement médical possible. > 12: chirurgie recommandée'
  },

  forrest: {
    name: 'Forrest (Hémorragie digestive)',
    category: 'Hépato-Gastro',
    icon: Droplets,
    description: 'Classification endoscopique hémorragie ulcéreuse',
    color: 'red',
    fields: [
      { id: 'class', label: 'Classification endoscopique', type: 'select', options: [
        { value: 'Ia', label: 'Ia - Saignement en jet' },
        { value: 'Ib', label: 'Ib - Saignement en nappe' },
        { value: 'IIa', label: 'IIa - Vaisseau visible non hémorragique' },
        { value: 'IIb', label: 'IIb - Caillot adhérent' },
        { value: 'IIc', label: 'IIc - Taches pigmentées' },
        { value: 'III', label: 'III - Fond propre' }
      ]}
    ],
    calculate: (values) => {
      return { score: values.class || 'III', max: 'Classification' };
    },
    interpret: (score) => {
      if (score === 'Ia') return { level: 'danger', text: 'Forrest Ia', detail: 'Saignement actif en jet. Hémostase endoscopique urgente. Récidive 55%.' };
      if (score === 'Ib') return { level: 'danger', text: 'Forrest Ib', detail: 'Saignement actif en nappe. Hémostase endoscopique. Récidive 55%.' };
      if (score === 'IIa') return { level: 'warning', text: 'Forrest IIa', detail: 'Vaisseau visible. Hémostase endoscopique recommandée. Récidive 43%.' };
      if (score === 'IIb') return { level: 'warning', text: 'Forrest IIb', detail: 'Caillot adhérent. Retrait + hémostase optionnelle. Récidive 22%.' };
      if (score === 'IIc') return { level: 'success', text: 'Forrest IIc', detail: 'Taches pigmentées. Pas d\'hémostase. Récidive 10%.' };
      return { level: 'success', text: 'Forrest III', detail: 'Fond propre. Pas d\'hémostase. Récidive 5%.' };
    },
    formula: 'I: saignement actif. II: stigmates récents. III: fond propre'
  }
};
